import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import "./Item.css";
import { useProject } from '../../ProjectContext';
import { detectallresult } from '../../api/aidetect/detectApi';
import Ai_Progess from "../../Images/utilImages/Ai_Progress.png"
// import Pothole from "../../Images/Item/PotholesIcon"
// import Crack from "../../Images/Item/CracksIcon"
// import Facility from "../../Images/Item/FacilitiesIcon"
// import FOD from "../../Images/Item/FODIcon"
// import Line from "../../Images/Item/FadedIcon"

const Item = () => {
  const { t } = useTranslation('map');
  const { projectInfo, setProjectInfo } = useProject();
  const [selectedItem, setSelectedItem] = useState(projectInfo.modelType || null);
  const { groupId, projectId, fileId } = projectInfo;
  const [showPopup, setShowPopup] = useState(false); // ✅ 팝업 상태 추가

  const [items, setItems] = useState([
    {
      key: "Pothole",
      title: `${t("item.pothole")}`,
      label: "Potholes",
      img: "/Images/PotholesIcon.png",
      value: 0,
      metric: "total_detections", // 👈 기본
    },
    {
      key: "Crack",
      title: `${t("item.crack")}`,
      label: "Cracks",
      img: "/Images/CracksIcon.png",
      value: 0,
      metric: "total_area_m2", // 👈 Crack만 다름
    },
    {
      key: "Facility",
      title: `${t("item.facility")}`,
      label: "Facilities",
      img: "/Images/FacilitiesIcon.png",
      value: 0,
      metric: "total_detections",
    },
    {
      key: "FOD",
      title: `${t("item.fod")}`,
      label: "FOD",
      img: "/Images/FODIcon.png",
      value: 0,
      metric: "total_detections",
    },
    {
      key: "Line",
      title: `${t("item.line")}`,
      label: "Faded",
      img: "/Images/FadedIcon.png",
      value: 0,
      metric: "total_detections",
    },
  ]);
  

  // ✅ 클릭 시 Context 업데이트
  const handleSelect = (key) => {
    setSelectedItem(key);
    setProjectInfo((prev) => ({
      ...prev,
      modelType: key,
    }));
  };

  // ✅ detectallresult API 호출
  useEffect(() => {
    if (!groupId || !projectId || !fileId) {
      console.warn("⚠️ detectallresult: 필수 ID 값이 없습니다.", { groupId, projectId, fileId });
      return;
    }
    
    const fetchDetectResult = async () => {
      try {
        const res = await detectallresult(groupId, projectId, fileId);
        const data = res.data || res;

        const modelData = Array.isArray(data.models) ? data.models : [];

        const updatedItems = items.map((item) => {
          const matched = modelData.find(
            (m) => m.model_name?.toLowerCase() === item.key.toLowerCase()
          );
          return {
            ...item,
            value: matched ? matched[item.metric] ?? 0 : 0,
          };
        });

        setItems(updatedItems);
      } catch (err) {
        console.error("❌ detectallresult 호출 실패:", err);

        // ✅ 404인 경우에만 팝업 표시
        if (err.response && err.response.status === 404) {
          setShowPopup(true);
        } else {
          // 그 외 오류는 단순 초기화
          setItems((prev) =>
            prev.map((item) => ({
              ...item,
              value: 0,
            }))
          );
        }
      }
    };

    fetchDetectResult();
  }, [ projectId, fileId]);

  // ✅ 팝업 확인 버튼 클릭 시 페이지 전체 새로고침
  const handleConfirm = () => {
    setShowPopup(false);
    window.location.reload(); // 전체 새로고침
  };

  return (
    <>
      <div className='Itemcomponent'>
        {items.map((item) => (
          <div
            key={item.key}
            className={`ItemBox ${selectedItem === item.key ? "active" : ""}`}
            onClick={() => handleSelect(item.key)}
          >
            <div className='Box'>
              <div className='ImageContainer'>
                <div className={`ImageBox ${selectedItem === item.key ? "active" : ""}`}>
                  <img src={item.img} alt={`${item.label} Icon`} className='iconimg' />
                </div>
                {item.title}
              </div>
              <div className='DataBox'>
              <div className='DataInfoBox'>
                {item.key === "Crack"
                  ? `${item.value.toFixed(2)} m²`
                  : item.value}
              </div>
            </div>
            </div>
          </div>
        ))}
      </div>

      {/* ✅ 404 발생 시 팝업 표시 */}
      {showPopup && (
        <div className="PopupContainer">
          <div className="PopupBox">
            <img className='Ai_Progress_img' src={Ai_Progess}/>
            <p style={{ fontSize: "16px", marginBottom: "24px" }}>
              AI 탐지 진행 중입니다.<br />다른 데이터를 선택해주세요.
            </p>
            <button className="ConfirmButton" onClick={handleConfirm}>
              확인
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Item;
